import { useContext } from 'react';
import { ADMIN_CHANNEL_OPT_IN, isCompanyOptionEnabled } from '@config/companyOptions';
import { UserContext } from '@providers/UserProvider/UserProvider';

export const useIsAdminChannelOptInEnabled = (): boolean => {
  const { company, is_admin: isAdmin, is_buyer: isBuyer } = useContext(UserContext);

  return Boolean(isAdmin && isBuyer && isCompanyOptionEnabled(company, ADMIN_CHANNEL_OPT_IN));
};
